// BroadcastChannel. Needed with Localforage/indexedDB to sync all store state/mutations to all browser tabs ---

// This broadcasts each mutation (type + payload) to other tabs and replays them there.
// It avoids infinite loops by stamping messages with a local origin id.

// By default, we use the 'registrationOutbox' namespace and channel name, but it is possible to use the same channel for multiple namespaces.

export function createVuexBroadcastPlugin(namespace = 'registrationOutbox', channelName = namespace) {
  const bc = new BroadcastChannel(channelName);
  const originId = `${Date.now()}-${Math.random()}`;
  const prefix = `${namespace}/`;
  let isApplyingRemote = false;

  return (store) => {
    // Broadcast outgoing mutations only for the given namespace, but skip when applying a remote mutation
    store.subscribe((mutation) => {
      if (!mutation || typeof mutation.type !== 'string') return;
      if (!mutation.type.startsWith(prefix)) return;
      if (isApplyingRemote) return;

      try {
        // console.log(`Broadcasted mutation: ${mutation.type}`);
        bc.postMessage({ originId, type: mutation.type, payload: mutation.payload });
      } catch (e) {
        // ignore post errors
      }
    });

    // Apply incoming mutations from other tabs only for the given namespace
    bc.onmessage = (event) => {
      const msg = event.data;
      if (!msg) return; // ignore invalid messages
      if (msg.originId === originId) return; // ignore messages from this tab
      if (!msg.type || !msg.type.startsWith(prefix)) return;

      try {
        isApplyingRemote = true;
        store.commit(msg.type, msg.payload);
      } catch (e) {
        // ignore unknown mutation commits
      } finally {
        isApplyingRemote = false;
      }
    };
  };
}
